import { render, staticRenderFns } from "./RouterContainer.vue?vue&type=template&id=37e9f53a&"
import script from "./RouterContainer.vue?vue&type=script&lang=js&"
export * from "./RouterContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports